import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useRouter } from "next/router";
import styles from "@aspen/theme/Wallet.module.less";
import type { IAssetWalletInfo, IBankAccount, IKycLevel } from "@aspen/model";
import { COMMON_CACHE_PRIORTY_KEYS } from "@aspen/model";
import { preWithdraw } from "@aspen/services";
import {
  GA_EVENT_NAME,
  USER_AUTH,
  USER_ROLE_POWER,
  WALLET_PATHS,
  reportEvent,
  i18nUtil,
} from "@aspen/libs";
import {
  WalletContext,
  useAppDispatch,
  useAppSelector,
  updateIsPreWithdraw,
  updateIsShowAmount,
  showAmount,
} from "@aspen/store";
import { useCachePriorityData, useFetchDepositCoinList } from "@aspen/hooks";
import { WithKYCInfo } from "@aspen/ui";
import { Dashboard, WalletCategoryDetails, ModalBankAccountStatus } from "@aspen/widgets";

interface IProps {
  showGuideModal: (level: IKycLevel, preventClose?: boolean) => boolean;
}

function Wallet(props: IProps) {
  const intl = i18nUtil.t();
  const title: string = intl["wallet"];
  const deposit = intl["button.deposit.crypto.currency"];
  const depositFiat = intl["button.deposit.fiat"];
  const whitelist = intl["button.withdraw.white.list.address"];

  const [showModal, setShowModal] = useState<boolean>(false);
  const [circleInfo, setCircleInfo] = useState<IBankAccount>();

  const router = useRouter();
  const dispatch = useAppDispatch();
  const isShowAmount = useAppSelector(showAmount);
  useEffect(() => {
    getInitData();
  }, []);

  // @ts-ignore
  const { mutate } = useCachePriorityData<IAssetWalletInfo>(COMMON_CACHE_PRIORTY_KEYS.walletInfo);
  useFetchDepositCoinList();

  // 初始化数据,
  const getInitData: () => void = () => {
    if (
      typeof window != "undefined" &&
      USER_ROLE_POWER[localStorage.getItem(USER_AUTH) ?? ""]?.depositAndWithdraw
    ) {
      preWithdraw().then(res => {
        if (res?.code == "0") {
          dispatch(updateIsPreWithdraw(res?.data));
        }
      });
    }
  };

  const getCircleInfo = params => {
    setCircleInfo(params);
  };

  const showCircleModal = () => {
    setShowModal(!showModal);
  };

  const goToDepositFiat = () => {
    router.push({
      pathname: WALLET_PATHS.WALLET_DEPOSIT_OTC,
    });
    reportEvent({ moduleName: "depositFait" });
  };

  return (
    <section className={`${styles.wallet} ` + `customer`}>
      <div className="customerTop">
        <Row className="top">
          <Col span={24}>
            <div className={styles.topTitleArea}>
              <div className={styles.leftTitleArea}>
                <span className="title">{title}</span>
                <div
                  style={{ display: "inline-block" }}
                  onClick={() => {
                    reportEvent({
                      moduleName: isShowAmount
                        ? GA_EVENT_NAME.wallet.hideAssets
                        : GA_EVENT_NAME.wallet.showAssets,
                    });
                    dispatch(updateIsShowAmount(!isShowAmount));
                  }}>
                  {isShowAmount ? (
                    <EyeOutlined className={styles.hideIcon} />
                  ) : (
                    <EyeInvisibleOutlined className={styles.hideIcon} />
                  )}
                </div>
              </div>
              {typeof window != "undefined" &&
                USER_ROLE_POWER[localStorage.getItem(USER_AUTH) ?? ""]?.depositAndWithdraw && (
                  <div className={styles.rightTitleArea}>
                    <Button
                      className={styles.whitelistBtn}
                      onClick={() => {
                        router.push(WALLET_PATHS.WALLET_WITHDRAW_WHITELIST_MANAGEMENT);
                      }}>
                      {whitelist}
                    </Button>

                    <Button
                      type="primary"
                      className={styles.allBtn}
                      onClick={() => {
                        router.push(WALLET_PATHS.WALLET_DEPOSIT);
                      }}>
                      {deposit}
                    </Button>
                    <Button type="primary" className={styles.allBtn} onClick={goToDepositFiat}>
                      {depositFiat}
                    </Button>
                  </div>
                )}
            </div>
          </Col>
        </Row>
      </div>
      <div className="section">
        <div className={styles.wallet}>
          {/* @ts-ignore */}
          <Dashboard showGuideModal={props.showGuideModal} />
          <WalletContext.Provider
            value={{ fetchWalletInfo: mutate, showCircleModal, getCircleInfo }}>
            <WalletCategoryDetails />
          </WalletContext.Provider>
          <ModalBankAccountStatus
            showModal={showModal}
            circleInfo={circleInfo}
            showCircleModal={showCircleModal}
          />
        </div>
      </div>
    </section>
  );
}

export const PageWallet = WithKYCInfo(Wallet);
